import { inject } from 'vue'
import { Auth } from '@/injectKeys.js'

export const useAuth = () => {
  return inject(Auth)
}
